/* eslint-disable react-hooks/exhaustive-deps */
import { Backdrop, Box, Button, CircularProgress, Fade, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { formatPrice } from "../../../utils";
import DriverPaymentService from "../../../services/driverPaymentService";
import PostService from "../../../services/postService";
import AddIcon from '@mui/icons-material/Add';


const AddPostDriverPaymentModal = ({
    open,
    handleClose,
    driverPayment,
    setPopupMsg,
    setPopupType,
    setShowPopup,
}) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isEn = i18n.language === 'en';
    const tableHeadingStyle = { fontWeight: 'bold', backgroundColor: theme.palette.customGrey.pdfTable };

    const [posts, setPosts] = useState({});
    const [isModalLoading, setIsModalLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const fetchDriverPosts = async () => {
        try {
            const filters = {
                driverId: driverPayment.driverId,
            };
            const data = await PostService.fetchForDriverPayment(filters);
            setPosts(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching driver payment:', error);
        }
    };

    const handleAdd = async (postId) => {
        try {
            setIsLoading(true);
            const data = await DriverPaymentService.addPost(driverPayment.id, postId);
            if (data.status === 200) {
                setPopupMsg(data.data.message);
                setPopupType('add');
                setShowPopup(true);
                handleClose({ isReaload: true });
            }

        } catch (error) {
            console.error("An unexpected error occurred:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setIsModalLoading(true);
        if (open) {
            fetchDriverPosts();
        }
    }, [open]);


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '98%' : '90%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isMobile ? 1 : 4,
                        height: '90vh',
                        overflowY: 'scroll'
                    }}
                >
                    {isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>

                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('addPostDriverPayment')}
                                </Typography>
                                <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                            </Box>

                            <TableContainer
                                component={Paper}
                                // ref={tableContainerRef}
                                id="tableContainer"
                                sx={{
                                    boxShadow: 'none',
                                    border: 1,
                                    borderColor: theme.palette.customGrey.borderInput,
                                    borderRadius: 2,
                                    height: 'calc(100vh - 280px)',
                                    overflowY: 'auto',
                                    width: '100%',
                                    mt: 2
                                }}
                            >
                                <Table stickyHeader aria-label="simple table">
                                    <TableHead
                                        sx={{
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 1
                                        }}
                                    >
                                        <TableRow>
                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('number')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('id')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('invoiceNumber')}
                                            </TableCell>

                                            {/* <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('receiverPhone')}
                                            </TableCell> */}

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('address')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('totalPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('driverPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('netPrice')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('note')}
                                            </TableCell>

                                            <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                                {t('actions')}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {posts.map((post, index) => (
                                            <TableRow
                                                key={post.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align={isEn ? 'left' : 'right'} component="th" scope="row">{index + 1}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.id}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.invoiceNumber}</TableCell>
                                                {/* <TableCell align={isEn ? 'left' : 'right'}>{post.receiverPhoneNumber}</TableCell> */}
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.receiverAddress}, {post.street.name}, {post.street.city.name}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.totalPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.driverPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{formatPrice(post.netPrice)}</TableCell>
                                                <TableCell align={isEn ? 'left' : 'right'}>{post.note}</TableCell>

                                                <TableCell align={isEn ? 'left' : 'right'}>
                                                    <Box sx={{
                                                        display: 'inline-flex',
                                                        border: 1,
                                                        borderColor: theme.palette.customGrey.borderInput,
                                                        backgroundColor: theme.palette.secondary.main,
                                                        borderRadius: 1,
                                                        cursor: isLoading ? 'not-allowed' : 'pointer',
                                                    }}>
                                                        <Box sx={{
                                                            px: 1.5,
                                                            pt: 0.6,
                                                            pb: 0.25,
                                                            cursor: 'pointer'
                                                        }}
                                                            onClick={() => {
                                                                handleAdd(post.id);
                                                            }}
                                                        >
                                                            <AddIcon fontSize='small'
                                                                sx={{ color: theme.palette.text.primary }} />
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 2
                            }}>
                                {/* close */}
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={handleClose}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('close')}</p>
                                        <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>

                                <Box width={20}></Box>

                            </Box>
                        </Box>
                    }
                </Box>
            </Fade>
        </Modal>
    );
}

export default AddPostDriverPaymentModal;
